import { render, staticRenderFns } from "./InstrumentList.vue?vue&type=template&id=6388e6bc&scoped=true"
import script from "./InstrumentList.vue?vue&type=script&lang=ts"
export * from "./InstrumentList.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentList.vue?vue&type=style&index=0&id=6388e6bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6388e6bc",
  null
  
)

export default component.exports